import { Validators } from '@angular/forms';

export class OriginatorBrokerModel{
  originator = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  broker = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  contact = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  salesPerson = {
    value: null,
    validation: Validators.compose([
    ])
  };
  salesSupport = {
    value: null,
    validation: Validators.compose([
    ])
  };
}
